import { Link } from "react-router-dom";

export const Monogram = ({ className = "h-8 w-8", dark = false }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <rect width="32" height="32" rx="5" fill={dark ? "#FFFFFF" : "#0B1220"} />
    <path d="M7.5 10.5h10M12.5 10.5v12" stroke={dark ? "#0B1220" : "#FFFFFF"} strokeWidth="2.4" strokeLinecap="square" />
    <path d="M18.5 15.5v7h6" stroke={dark ? "#0B1220" : "#FFFFFF"} strokeWidth="2.4" strokeLinecap="square" fill="none" />
    <path d="M12.5 10.5C15.5 5.8 20.5 5.2 24.5 8.5" stroke="#2563EB" strokeWidth="1.6" fill="none" strokeLinecap="round" />
    <circle cx="24.5" cy="8.5" r="1.9" fill="#2563EB" />
  </svg>
);

export const Logo = ({ dark = false, testId = "site-logo" }) => (
  <Link to="/" className="group inline-flex items-center gap-2.5" aria-label="Trusted Leap home" data-testid={testId}>
    <Monogram dark={dark} />
    <span className={`font-display text-[19px] tracking-[-0.04em] ${dark ? "text-white" : "text-[#0B1220]"}`}>
      <span className="font-extrabold">Trusted</span>
      <span className="font-light">Leap</span>
    </span>
  </Link>
);
